define('views/content/country_distributor',['require','views/base/item_page_view','typeahead','bloodhound','jquery.scrollbar','views/components/reseller_product_compact/reseller_products','collections/cd_products','views/components/reseller/resellers','collections/resellers','views/components/distributor/distributors','collections/distributors','views/components/action_history/action_histories','collections/action_histories','models/cd_manager','text!templates/content/country_distributor.html'],function(require){

    var BaseItemPageView = require('views/base/item_page_view');
    require('typeahead');
    require('bloodhound');
    require('jquery.scrollbar');

    var CompactResellerProductsView = require('views/components/reseller_product_compact/reseller_products');
    var CDProductsCollection = require('collections/cd_products');


    var ReselellersView = require('views/components/reseller/resellers');
    var ReselellersCollection = require('collections/resellers');

    var DistributorsView = require('views/components/distributor/distributors');
    var DistributorsCollection = require('collections/distributors');

    var ActionsView = require('views/components/action_history/action_histories');
    var ActionsCollection = require('collections/action_histories');

    var CDManagerModel = require('models/cd_manager');

    var temp = require("text!templates/content/country_distributor.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'cd-page page',
        basePath: 'country-distributors',
        titleKey: 'country_distributor',

        afterInitialize: function () {
            this.productsCollection = new CDProductsCollection([], {
                parameters: {
                    'country_distributor_id': this.model.id
                }
            });
            this.productsCollection.limit = 100;

            this.distributorsCollection = new DistributorsCollection([], {
                parameters: {
                    'country_distributor_id': this.model.id
                }
            });

            this.actionsCollection = new ActionsCollection([], {
                parameters: {
                    'cd_id': this.model.id
                }
            });


            // If creating a new object, add manager object to the model
            if (!this.model.get('id')) {
                this.model.set('manager', new CDManagerModel().attributes);
                this.model.get('manager').password = '';
                this.model.get('manager').password_confirm = '';
            }
        },

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',
                mainForm : '#main-form',
                submitButton: '#submit-button',
                cityField: '.cities-typeahead',
                countrySelect: '#country',
                stateSelect: '#state',
                phoneCountrySelect: '#phone_country',
                managerPhoneCountrySelect: '#manager__phone_country',
                licenseList: '.license-list',

                walletCount: '#wallet_count',
                walletDetail: '#wallet_detail',
                changeWalletButton: '#change-walet-button'
            };
        },

        events: {
            'change form input': 'formChanged',
            'change form textarea': 'formChanged',
            'change form select': 'formChanged',

            'click @ui.submitButton': 'submitButtonClicked',
            'change @ui.countrySelect': 'countryChanged',

            'click @ui.changeWalletButton': 'changeWalletButtonClicked'
        },

        regions: function() {
            return {
                LicensesContainer: ".license-list",
                DistributorsContainer: ".distributor-list",
                ActionsContainer: ".action-list",
            };
        },
        afterRender: function () {
            var _this = this;

            if (this.model.get('id')) {
                this.LicensesContainer.show(new CompactResellerProductsView({
                    collection: this.productsCollection
                }));

                this.DistributorsContainer.show(new DistributorsView({
                    collection: this.distributorsCollection
                }));

                this.ActionsContainer.show(new ActionsView({
                    collection: this.actionsCollection
                }));

            }



            // Setup typeahed for city field
            var citiesTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'cities/typeahead/',
                    replace: function(url, query) {
                        var modifiedUrl = url + ('?query=' + _this.ui.cityField.val());

                        if (_this.model.get('country')) {
                            modifiedUrl += ('&country=' + _this.model.get('country'));
                        }

                        return modifiedUrl;
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.cityField.typeahead({
                minLength: 3
            }, {
                name: 'cities',
                source: citiesTypeahedEngine,
                display: 'name'
            });
            // Get selected cities name
            this.ui.cityField.bind('typeahead:select', function (ev, suggestion) {
                _this.model.set('city_name', suggestion.name);
            });
            
            this.ui.licenseList.scrollbar();
        },

        setupFormValidation: function () {
            this.ui.mainForm.validate({
                rules: {
                    'company_name': "required",
                    'country': "required",
                    'city_name': "required",
                    'phone_country': "required",
                    'phone_value': "required",
                    'foundation_year': "required",
                    'service_languages': "required",
                    "service_types": "required",
                    'address': "required",
                    'group': "required",

                    'manager__first_name': "required",
                    'manager__last_name': "required",
                    'manager__email': "required",
                    'manager__phone_country': "required",
                    'manager__phone_value': "required",
                    'manager__password': "required",
                    'manager__password_confirm': {
                        equalTo: '[name="manager__password"]'
                    }
                },
                messages: {
                    'company_name': App.polyglot.t('company_name_required'),
                    'country': App.polyglot.t('country_required'),
                    'city_name': App.polyglot.t('city_required'),
                    'phone_country': App.polyglot.t('phone_country_required'),
                    'phone_value': App.polyglot.t('phone_value_required'),
                    'foundation_year': App.polyglot.t('foundation_year_required'),
                    'service_languages': App.polyglot.t('service_languages_required'),
                    "service_types": App.polyglot.t('service_types_required'),
                    'address': App.polyglot.t('address_required'),
                    'group': App.polyglot.t('group_required'),

                    'manager__first_name': App.polyglot.t('manager_first_name_required'),
                    'manager__last_name': App.polyglot.t('manager_last_name_required'),
                    'manager__email': App.polyglot.t('manager_email_required'),
                    'manager__phone_country': App.polyglot.t('manager_phone_country_required'),
                    'manager__phone_value': App.polyglot.t('manager_phone_value_required'),
                    'manager__password': App.polyglot.t('password_required'),
                    'manager__password_confirm': {
                        equalTo: App.polyglot.t('password_confirm_must_match')
                    }

                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        },

        countryChanged: function () {
            var country_id = this.ui.countrySelect.val();

            if (country_id) {
                // Select same country in phone number field
                this.ui.phoneCountrySelect.val(country_id);
                this.ui.phoneCountrySelect.trigger('change');
                this.ui.managerPhoneCountrySelect.val(country_id);
                this.ui.managerPhoneCountrySelect.trigger('change');
                
                // Reset state and re render for state options of country
                this.ui.stateSelect.val(null);
                this.ui.stateSelect.trigger('change');
                this.render();

            }
        },


        changeWalletButtonClicked: function () {
            var _this = this;

            var walletCount = this.ui.walletCount.val();
            var walletDetail = this.ui.walletDetail.val();

            if (walletCount >= 0 && walletDetail.length > 10) {
                _this.ui.changeWalletButton.addClass('loading');

                $.ajax({
                    url: App.Config.apiBase + 'country-distributors/' + this.model.get('id') + '/set_cd_wallet/',
                    method: 'post',
                    data: {
                        wallet: walletCount,
                        note: walletDetail
                    },
                    success: function (response) {
                        _this.ui.changeWalletButton.removeClass('loading');
                        _this.model.set(response);
                        _this.render();

                        App.utils.showMessage('success', App.polyglot.t('update_wallet_success'));
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        _this.ui.changeWalletButton.removeClass('loading');

                        // Show error messages
                        if (xhr.responseJSON.errors) {
                            for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
                                App.utils.showMessage('error', xhr.responseJSON.errors[i].message);
                            }
                        }
                    }
                });
            } else {
                if (walletCount < 0) {
                    App.utils.showMessage('error', App.polyglot.t('wallet_must_be_greater_than_zero'));
                }
                if (walletDetail.length <= 10) {
                    App.utils.showMessage('error', App.polyglot.t('note_length_must_be_greater_than_ten'));
                }
            }
        },

    });
});
